import React from 'react';
import { MessageCircle } from 'lucide-react';

const WhatsAppButton = () => {
  const phoneNumber = '4917346115 27'; // Format: country code + number without + or spaces
  const message = 'Hallo! Ich interessiere mich für Ihren Maschinen- und Fahrzeugverleih.';
  
  const whatsappUrl = `https://wa.me/${phoneNumber.replace(/\s/g, '')}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 left-6 z-50 w-16 h-16 bg-[#25D366] hover:bg-[#20BA5A] rounded-full shadow-2xl flex items-center justify-center transition-all hover:scale-110 group"
      aria-label="WhatsApp kontaktieren"
    >
      <MessageCircle className="h-8 w-8 text-white group-hover:scale-110 transition-transform" />
      <span className="absolute -top-1 -right-1 w-4 h-4 bg-white rounded-full border-2 border-[#25D366] flex items-center justify-center">
        <span className="text-xs text-[#25D366] font-bold">W</span>
      </span>
    </a>
  );
};

export default WhatsAppButton;
